import { render, staticRenderFns } from "./SupplierADetail.vue?vue&type=template&id=dea71b76&scoped=true&"
import script from "./SupplierADetail.vue?vue&type=script&lang=js&"
export * from "./SupplierADetail.vue?vue&type=script&lang=js&"
import style0 from "./SupplierADetail.vue?vue&type=style&index=0&id=dea71b76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea71b76",
  null
  
)

export default component.exports